/**
 * Product Filter Groups
 * @author Kate York
 */

// Utilities
import debug from "debug";
const log  = debug('core/modules/forms/product-filter-groups');
const ATTR = 'data-set-current-filter-group';
const HIDDEN = '[name="CurrentFilterGroup"]';
const SELECTOR = `[${ATTR}]`;
const CHANGEFILTERS = '.product__filter-item--checkbox,.product__filter-item--radio';
const LOADINGPANEL = '.product-filter__loading-panel';

export default function () {

    $(document).ready(() => {
        const $selectField = $(SELECTOR);
        const $changeField = $(HIDDEN);

        setTimeout(function(){
            $(LOADINGPANEL).removeClass('active');
            $(CHANGEFILTERS).fadeIn();
        }, 200);

        log('binding data-set-current-filter-group to', $selectField);

        $selectField
            .on('change', function onChanged () {
                const $this = $(this);
                var selectFieldValue = $this.attr(ATTR);
                log($this, 'changed. updating current filter group');
                $changeField.val(selectFieldValue);
            });
    });
}


// WEBPACK FOOTER //
// ./project/client/src/core/modules/forms/product-filter-groups.js